import React, { useState } from 'react';
import { Alert, Box, Card, CardContent, Tab, Tabs } from '@mui/material';
import { useAccessControl } from '../../hooks/useAccessControl';
import { RESOURCES, ACTIONS } from '../../hooks/usePermissions';
import ModulePageHeader from '../common/ModulePageHeader';
import BudgetsTab from './budgeting/BudgetsTab';
import VsActualTab from './budgeting/VsActualTab';
import TransfersTab from './budgeting/TransfersTab';
import RolloverTab from './budgeting/RolloverTab';

const TABS = [
  { value: 'budgets', label: 'Budgets', Component: BudgetsTab },
  { value: 'vsActual', label: 'Vs Actual', Component: VsActualTab },
  { value: 'transfers', label: 'Transfers', Component: TransfersTab },
  { value: 'rollover', label: 'Rollover', Component: RolloverTab },
];

// Budgeting: spending envelopes per (GL account x fiscal period) with a
// maker-checker lifecycle (config/ledger.php section 'budgeting'). Vs Actual
// ties each line to posted actuals; transfers (virements) move envelope
// between lines; rollover carries unspent balances into the next year.
const Budgeting = () => {
  const { can } = useAccessControl();
  const [tab, setTab] = useState('budgets');

  if (!can(RESOURCES.LEDGER.BUDGETING, ACTIONS.READ)) {
    return <Alert severity="error">You do not have permission to view Budgeting.</Alert>;
  }

  const Active = TABS.find((t) => t.value === tab)?.Component;

  return (
    <Box>
      <ModulePageHeader
        title="Budgeting"
        subtitle="Spending envelopes, variance tracking, virements and year-end rollover"
      />
      <Card sx={{ mb: 3 }}>
        <CardContent sx={{ pb: '8px !important', pt: '4px !important' }}>
          <Tabs value={tab} onChange={(_, v) => v && setTab(v)} variant="scrollable" scrollButtons="auto">
            {TABS.map((t) => (
              <Tab key={t.value} value={t.value} label={t.label} />
            ))}
          </Tabs>
        </CardContent>
      </Card>

      {Active && <Active />}
    </Box>
  );
};

export default Budgeting;
